import * as PIXI from 'pixi.js';
import Element from '../../Prototype/UI/Element';
import UIComponent from './UIComponent';

export interface IPadding {
    left: number;
    top: number;
    bottom: number;
    right: number;
}

export default class UIVerticalGroupComponent extends UIComponent {
    public UIComponent: PIXI.ui.component.VerticalGroup;

    public attach(gameObject: Element, params: any): void {
        this.UIComponent = new PIXI.ui.component.VerticalGroup(
            {
                left: params.data.padding[0],
                top: params.data.padding[1],
                right: params.data.padding[2],
                bottom: params.data.padding[3],
            },
            params.data.spacing
        );

        gameObject.container.add(this.UIComponent);

        super.attach(gameObject, params);
    }
    public padding: IPadding = undefined;
    public spacing: number = undefined;
}
